import { FUNC_DEFAULT, OBJECT_DEFAULT } from 'constants';
import PaytoErrorCodeModal from 'features/to/modals/PaytoErrorCodeModal';
import { isFunction } from 'lodash';
import React, { useState } from 'react';

const withPaytoErrorCodeModal = (Component) => {
  const PaytoErrorCodeModalComponent = (props) => {
    const [isOpenModal, setOpenModal] = useState();
    const [errorData, setErrorData] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [modalContent, setModalContent] = useState('');
    const [modalAction, setModalAction] = useState(FUNC_DEFAULT);
    const [buttonLabel2, setButtonLabel2] = useState('');
    const [modalOptions, setModalOptions] = useState(OBJECT_DEFAULT);
    const [modalData, setModalData] = useState(OBJECT_DEFAULT);

    const onOpenPaytoErrorCodeModal = (
      errorData = OBJECT_DEFAULT,
      title = '',
      content = '',
      action = FUNC_DEFAULT,
      buttonLabel2 = '',
      modalOptions = OBJECT_DEFAULT,
      modalData = OBJECT_DEFAULT
    ) => {
      setErrorData(errorData);
      setModalTitle(title);
      setModalContent(content);
      setModalAction(action);
      setOpenModal(true);
      setButtonLabel2(buttonLabel2);
      setModalOptions(modalOptions);
      setModalData(modalData);
    };
    const onClosePaytoErrorCodeModal = () => {
      setOpenModal(false);
      isFunction(modalAction) && modalAction();
    };

    const renderPaytoErrorCodeModal = () => {
      if (!isOpenModal) return null;
      return (
        <PaytoErrorCodeModal
          isShow={isOpenModal}
          action={onClosePaytoErrorCodeModal}
          errorData={errorData}
          title={modalTitle}
          content={modalContent}
          buttonLabel2={buttonLabel2}
          modalOptions={modalOptions}
          modalData={modalData}
        />
      );
    };

    const newProps = {
      ...props,
      onOpenPaytoErrorCodeModal,
    };
    return (
      <>
        {renderPaytoErrorCodeModal()}
        <Component {...newProps} />
      </>
    );
  };
  return PaytoErrorCodeModalComponent;
};

export default withPaytoErrorCodeModal;
